(function (ng, app) {

    notificationsController.$inject = ["$mdDialog", "$state", "$cookies", "amplitudeService"];
    app.controller("notificationsController", notificationsController);
    function notificationsController($mdDialog, $state, $cookies, amplitudeService) {
        var $ctrl = this;      

        ng.extend($ctrl,
            {
                closeDialog: closeDialog
            });

        function closeDialog($event) {

            if ($ctrl.notification === 'covid-19') {
                var expireDate = new Date();
                expireDate.setDate(expireDate.getDate() + 1);  //expriration date in 24 hrs
                $cookies.put('hide-covid-notification', true, { 'expires': expireDate });
            }

            $mdDialog.hide($event);
        }

        $ctrl.goToState = function ($event) {
            $state.go($event).then(function () {
                $ctrl.logAmplitude('Covid 19 Pop-up Details');
                closeDialog($event);
            });
        };

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

        $ctrl.$onInit = function () {
        };
    }
})(window.angular, window.app); //jshint ignore:line